// 文章1数据信息
export default {
  id: '300',
  title: '动龄健康公司简介',
  createTime: '2025-03-20 10:00:00',
  content: `深圳市动龄健康科技服务有限公司是一家以运动医学为基石，专注中老年健康管理领域的科技服务公司。通过 "科学运动干预 + 智能技术整合" 双轮驱动,为 B 端医疗机构/养老机构/康复机构和 C 端中老年家庭提供全场景健康解决方案。

![img](https://cdn.keihong.tech/img/20250422163411189.png)

公司品牌“动龄健康”，取意为科学运动，才能冻龄（保持年轻），收获健康。公司倡导“科学运动是最好的健康良方”理念，通过独创的“年长者体适能课程体系”和获得国家专利的线上康复解决方案，致力于实现 "为一亿中国长者延长十年正常生活" 的愿景。其核心竞争力在于将运动医学实践与智能技术深度结合，构建起覆盖 "评估 - 干预 - 监测" 全流程的数字化健康管理平台。

![img](https://cdn.keihong.tech/img/20250422163411193.png)`
}
